export default "__VITE_ASSET__BEhqHm$3__"